module.exports = __webpack_public_path__ + "img/tab03.6f088158.png";